import React, { useEffect, useState } from "react";
import { apiGet } from "../../utils/api";
import { FaBoxOpen, FaTicketAlt, FaUsers } from "react-icons/fa";
import { StatCard, PageHeader, Spinner } from "../../components/ui";

export default function AdminDashboard() {
  const [stats, setStats] = useState({
    plans: 0,
    coupons: 0,
    users: 0,
    loading: true,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [plansRes, couponsRes, usersRes] = await Promise.all([
          apiGet("/api/plans"),
          apiGet("/api/coupons"),
          apiGet("/api/admin/users"),
        ]);

        setStats({
          plans: plansRes?.plans?.length || 0,
          coupons: couponsRes?.coupons?.length || 0,
          users: usersRes?.users?.length || 0,
          loading: false,
        });
      } catch (err) {
        console.error("Failed to load admin stats", err);
        setStats((prev) => ({ ...prev, loading: false }));
      }
    };

    fetchStats();
  }, []);

  if (stats.loading) {
    return (
      <div className="flex items-center justify-center min-h-[300px]">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div>
      <PageHeader title="Admin Dashboard" subtitle="Overview of your platform" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <StatCard label="Plans" value={stats.plans} icon={FaBoxOpen} />
        <StatCard label="Coupons" value={stats.coupons} icon={FaTicketAlt} />
        <StatCard label="Users" value={stats.users} icon={FaUsers} />
      </div>
    </div>
  );
}
